import { Navigate } from "react-router-dom";

// ProtectedRoute component to check authentication & role
const ProtectedRoute = ({ children, allowedRoles }) => {

 
  const authToken = localStorage.getItem("access_token"); 
  const userRole = localStorage.getItem("role"); 
  
  // 🚨 Also check if we have user data
  const userData = localStorage.getItem("user_data");
  const userId = localStorage.getItem("userId");

  // If user is not logged in, redirect to login page
  if (!authToken || !userId) {
    return <Navigate to="/" replace />;
  }

  // If user's role is not in allowedRoles, redirect to unauthorized page
  if (allowedRoles && allowedRoles.length > 0) {
    if (!allowedRoles.includes(userRole)) {
      return <Navigate to="/" replace />;
    }
  }

  return children;
};

export default ProtectedRoute;